import React, { useState, useEffect } from "react";

import useFetchObjectByPost from "../../../../components/Hooks/useFetchObjectByPost";
import { sto } from "../../../../Context/InshData";
import { uri } from "../../../../help/Api";
import LoadingPage from "../../../../services/LoadingPage";
import SafesTransfer from "./SafesTransfer";
const defaultAutos = {
  Safes: [],
};
const defaultAutosEmp = {
  SafesEmp: [],
};


export default function SafesTransferCon() {
  
  
  const tb = {
    wait: true,
    Safe: true,
    SafeEmp:true,
    Branch: true,
    costcenters:true,
    other: true,
    Units: true,
    EmpItems:true,
    PermissionsElemnts:true,
    stor: sto,
    parms: { safe: -1,tname:"Transfer" ,      
      iempid: sto.empi,
      branch:sto.branchi,
      iformid: 70009,
      iuserid: sto.idi,
      db_name:sto?.db_name
    },
  };

  const { object: AutoOptions, fetching: fetchAll } = useFetchObjectByPost(
    uri + "GetD",
    tb
  );

  if (fetchAll || !AutoOptions?.Safes) return <LoadingPage />;

  return (
    <SafesTransfer
      {...{
        AutoOptions: AutoOptions?.Safes ? AutoOptions : defaultAutos,
        isEstelam:false,
      }}
    />
  );
}
